<template>
  <a
    href="#"
    class="btn btn-white"
    @click.prevent="invite()"
  >
    <i class="fa fa-paper-plane" /> {{ __('Convidar Usuário') }}
  </a>
</template>

<script>
export default {
  props: ['reload'],

  methods: {
    invite () {
      Bus.$emit('inviteUserButtonToggled', this.reload);
    },
  },
};
</script>
